import { render, staticRenderFns } from "./magazine-select-dialog.component.vue?vue&type=template&id=77f2792e"
import script from "./magazine-select-dialog.component.vue?vue&type=script&lang=js"
export * from "./magazine-select-dialog.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports